// extracted by mini-css-extract-plugin
export var imageHeaderContainer = "imageheader-module--image-header-container--43503";